import { render } from "./ArgonAlert.vue?vue&type=template&id=325422c9&scoped=true"
import script from "./ArgonAlert.vue?vue&type=script&lang=js"
export * from "./ArgonAlert.vue?vue&type=script&lang=js"

import "./ArgonAlert.vue?vue&type=style&index=0&id=325422c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325422c9"]])

export default __exports__